import React, {Component} from 'react';
import List, {ListItem} from 'material-ui/List';
import dateformat from 'dateformat';
class Pedido extends Component {
    render() {
        if (!this.props.show) return null;

        return (
            <ListItem 
                innerDivStyle={this.props.innerDivStyle} 
                disableTouchRipple={true} 
                rightIcon={this.props.rightIcon}>
                
                <h4 style={{marginTop:5}}>Datos de la Solicitud</h4>

                <strong>No. Pedido:</strong> <span>{this.props.pedido.id}</span> <br/>
                <strong>Fecha de solicitud:</strong><span> {dateformat(new Date(this.props.pedido.created_at),'dd-mm-yyyy')}</span><br/><br/>

                <ul style={{lineHeight:1.5, listStyle: 'none', margin:0, padding:0}}>
                    <li>
                        <strong>Total a pagar: </strong>
                        <div> {parseFloat(this.props.pedido.total_pagar).bs()}</div>
                    </li>

                    <li>
                        <strong>Pagos sin verificar: </strong>
                        <div> {parseFloat(this.props.pedido.pagado_sv).bs()}</div>
                    </li>

                    <li>
                        <strong>Pagos verificados:</strong>
                        <div> {parseFloat(this.props.pedido.pagado_v).bs()}</div>
                    </li>
                </ul>
            </ListItem>
        );
    }
}

export default Pedido;


/** WEBPACK FOOTER **
 ** ./app-react/components/Suscripcion/Pedido.jsx
 **/